var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as _ from "lodash";
import { RouteFiller } from "../helpers/Helpers";
import { CollaborationServiceSetup } from "../Setup";
export var CustomerInformationController = {
    /*****************************************************************************************************
        * Is using route "api/customerInformation/filtered/{groupId}/{year}/{countryCode?}/{contentLocationId?}/{categoryId?}" and http method "GET" to call the back-end.
    
        * @param {string} groupId
        * @param {number} year
        * @param {string} countryCode
        * @param {string} contentLocationId
        * @param {string} categoryId
        * @returns {PersonaInformationElementDownloadDto[]}
    ******************************************************************************************************/
    GetInformationElements: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/customerInformation/filtered/{groupId}/{year}/{countryCode?}/{contentLocationId?}/{categoryId?}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/customerInformation/allgroups/filtered/{year}/{countryCode?}/{contentLocationId?}/{categoryId?}" and http method "GET" to call the back-end.
    
        * @param {number} year
        * @param {string} countryCode
        * @param {string} contentLocationId
        * @param {string} categoryId
        * @returns {PersonaInformationElementDownloadDto[]}
    ******************************************************************************************************/
    GetInformationElementsForAllGroups: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/customerInformation/allgroups/filtered/{year}/{countryCode?}/{contentLocationId?}/{categoryId?}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/customerInformation/single/{id}" and http method "GET" to call the back-end.
    
        * @param {string} id
        * @returns {InformationElementDownloadDto}
    ******************************************************************************************************/
    GetInformationElement: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/customerInformation/single/{id}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/customerInformation/{id}" and http method "DELETE" to call the back-end.
    
        * @param {string} id
        * @returns {InformationElementDownloadDto}
    ******************************************************************************************************/
    DeleteInformationElement: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/customerInformation/{id}", __assign({}, data)),
            method: "DELETE",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/customerInformation/persona/{id}" and http method "PATCH" to call the back-end.
    
        * @param {string} id
        * @param {PersonaInformationElementUploadDto} persona
        * @param {File} profileImage
        * @param {{[key: string]: File}} otherImages
        * @returns {PersonaInformationElementDownloadDto}
    ******************************************************************************************************/
    UpdatePersona: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("persona", JSON.stringify(data.persona));
        if (data.profileImage)
            fd.append("profileImage", data.profileImage);
        _.forEach(data.otherImages, function (val, key) { return fd.append(key, val); });
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/customerInformation/persona/{id}", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/customerInformation/data/{id}" and http method "PATCH" to call the back-end.
    
        * @param {string} id
        * @param {DataInformationElementUploadDto} data
        * @returns {DataInformationElementDownloadDto}
    ******************************************************************************************************/
    UpdateData: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("data", JSON.stringify(data.data));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/customerInformation/data/{id}", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/customerInformation/value/{id}" and http method "PATCH" to call the back-end.
    
        * @param {string} id
        * @param {ValueInformationElementUploadDto} data
        * @returns {ValueInformationElementDownloadDto}
    ******************************************************************************************************/
    UpdateValue: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("data", JSON.stringify(data.data));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/customerInformation/value/{id}", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/customerInformation/media/{id}" and http method "PATCH" to call the back-end.
    
        * @param {string} id
        * @param {MediaInformationElementUploadDto} data
        * @param {File} mediaBytes
        * @returns {ValueInformationElementDownloadDto}
    ******************************************************************************************************/
    UpdateMedia: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("data", JSON.stringify(data.data));
        if (data.mediaBytes)
            fd.append("mediaBytes", data.mediaBytes);
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/customerInformation/media/{id}", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/customerInformation/media/{groupid}" and http method "POST" to call the back-end.
    
        * @param {string} groupid
        * @param {MediaInformationElementUploadDto} data
        * @param {File} mediaBytes
        * @returns {MediaInformationElementDownloadDto}
    ******************************************************************************************************/
    PostMedia: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("data", JSON.stringify(data.data));
        if (data.mediaBytes)
            fd.append("mediaBytes", data.mediaBytes);
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/customerInformation/media/{groupid}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/customerInformation/send/mail" and http method "POST" to call the back-end.
    
        * @param {string} content
        * @returns {void}
    ******************************************************************************************************/
    SendEmail: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("content", JSON.stringify(data.content));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/customerInformation/send/mail", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/customerInformation/value/{groupid}" and http method "POST" to call the back-end.
    
        * @param {string} groupid
        * @param {ValueInformationElementUploadDto} data
        * @param {File} mediaBytes
        * @returns {ValueInformationElementDownloadDto}
    ******************************************************************************************************/
    PostValue: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("data", JSON.stringify(data.data));
        if (data.mediaBytes)
            fd.append("mediaBytes", data.mediaBytes);
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/customerInformation/value/{groupid}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/customerInformation/excel/persona/{groupId}" and http method "POST" to call the back-end.
    
        * @param {string} groupId
        * @param {File} excelFile
        * @returns {PersonaInformationElementDownloadDto[]}
    ******************************************************************************************************/
    ImportPersonaExcel: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.excelFile)
            fd.append("excelFile", data.excelFile);
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/customerInformation/excel/persona/{groupId}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/customerInformation/excel/values/{groupId}" and http method "POST" to call the back-end.
    
        * @param {string} groupId
        * @param {File} excelFile
        * @returns {ValueInformationElementDownloadDto[]}
    ******************************************************************************************************/
    ImportValuesExcel: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.excelFile)
            fd.append("excelFile", data.excelFile);
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/customerInformation/excel/values/{groupId}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/customerInformation/remove/data/{groupId}/{countryCode}/{year}/{source?}" and http method "DELETE" to call the back-end.
    
        * @param {string} groupId
        * @param {string} countryCode
        * @param {number} year
        * @param {string} source
        * @returns {void}
    ******************************************************************************************************/
    DeleteAllData: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/customerInformation/remove/data/{groupId}/{countryCode}/{year}/{source?}", __assign({}, data)),
            method: "DELETE",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/customerInformation/move/data/{groupId}/{targetGroup}/{year?}/{countryCode?}/{source?}" and http method "POST" to call the back-end.
    
        * @param {string} groupId
        * @param {string} targetGroup
        * @param {number | null} year
        * @param {string} countryCode
        * @param {string} source
        * @returns {void}
    ******************************************************************************************************/
    MoveDataToOtherGroup: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/customerInformation/move/data/{groupId}/{targetGroup}/{year?}/{countryCode?}/{source?}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/customerInformation/setUnsetYears/{groupId}/{year}" and http method "POST" to call the back-end.
    
        * @param {string} groupId
        * @param {number} year
        * @returns {void}
    ******************************************************************************************************/
    SetUnsetYears: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/customerInformation/setUnsetYears/{groupId}/{year}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/customerInformation/updatePositions/{groupId}/{year}" and http method "POST" to call the back-end.
    
        * @param {string} groupId
        * @param {number} year
        * @returns {void}
    ******************************************************************************************************/
    UpdatePositions: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/customerInformation/updatePositions/{groupId}/{year}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/customerInformation/excel/data/pss2019/{groupId}/{countryCode}" and http method "POST" to call the back-end.
    
        * @param {string} groupId
        * @param {string} countryCode
        * @param {File} excelFile
        * @returns {DataInformationElementDownloadDto[]}
    ******************************************************************************************************/
    ImportPss2019DataExcel: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.excelFile)
            fd.append("excelFile", data.excelFile);
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/customerInformation/excel/data/pss2019/{groupId}/{countryCode}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/customerInformation/excel/data/ncbs2019/{groupId}/{countryCode}" and http method "POST" to call the back-end.
    
        * @param {string} groupId
        * @param {string} countryCode
        * @param {File} excelFile
        * @returns {DataInformationElementDownloadDto[]}
    ******************************************************************************************************/
    ImportNcbs2019DataExcel: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.excelFile)
            fd.append("excelFile", data.excelFile);
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/customerInformation/excel/data/ncbs2019/{groupId}/{countryCode}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/customerInformation/excel/data/cap2019/{groupId}/{countryCode}" and http method "POST" to call the back-end.
    
        * @param {string} groupId
        * @param {string} countryCode
        * @param {File} excelFile
        * @returns {DataInformationElementDownloadDto[]}
    ******************************************************************************************************/
    ImportCaP2019DataExcel: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.excelFile)
            fd.append("excelFile", data.excelFile);
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/customerInformation/excel/data/cap2019/{groupId}/{countryCode}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/customerInformation/excel/data/vx2019/{groupId}" and http method "POST" to call the back-end.
    
        * @param {string} groupId
        * @param {File} excelFile
        * @returns {DataInformationElementDownloadDto[]}
    ******************************************************************************************************/
    ImportVx2019DataExcel: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.excelFile)
            fd.append("excelFile", data.excelFile);
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/customerInformation/excel/data/vx2019/{groupId}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/customerInformation/excel/data/vci2019/{groupId}" and http method "POST" to call the back-end.
    
        * @param {string} groupId
        * @param {File} excelFile
        * @returns {DataInformationElementDownloadDto[]}
    ******************************************************************************************************/
    ImportVci2019DataExcel: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.excelFile)
            fd.append("excelFile", data.excelFile);
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/customerInformation/excel/data/vci2019/{groupId}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/customerInformation/excel/data/pss2020/{groupId}/{countryCode}" and http method "POST" to call the back-end.
    
        * @param {string} groupId
        * @param {string} countryCode
        * @param {File} excelFile
        * @returns {DataInformationElementDownloadDto[]}
    ******************************************************************************************************/
    ImportPss2020DataExcel: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.excelFile)
            fd.append("excelFile", data.excelFile);
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/customerInformation/excel/data/pss2020/{groupId}/{countryCode}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/customerInformation/excel/data/pss2021/{groupId}/{countryCode}" and http method "POST" to call the back-end.
    
        * @param {string} groupId
        * @param {string} countryCode
        * @param {File} excelFile
        * @returns {DataInformationElementDownloadDto[]}
    ******************************************************************************************************/
    ImportPss2021DataExcel: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.excelFile)
            fd.append("excelFile", data.excelFile);
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/customerInformation/excel/data/pss2021/{groupId}/{countryCode}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/customerInformation/excel/data/pss2022/{groupId}/{countryCode}" and http method "POST" to call the back-end.
    
        * @param {string} groupId
        * @param {string} countryCode
        * @param {File} excelFile
        * @returns {DataInformationElementDownloadDto[]}
    ******************************************************************************************************/
    ImportPss2022DataExcel: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.excelFile)
            fd.append("excelFile", data.excelFile);
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/customerInformation/excel/data/pss2022/{groupId}/{countryCode}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/customerInformation/excel/data/pss2023/{groupId}/{countryCode}" and http method "POST" to call the back-end.
    
        * @param {string} groupId
        * @param {string} countryCode
        * @param {File} excelFile
        * @returns {DataInformationElementDownloadDto[]}
    ******************************************************************************************************/
    ImportPss2023DataExcel: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.excelFile)
            fd.append("excelFile", data.excelFile);
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/customerInformation/excel/data/pss2023/{groupId}/{countryCode}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/customerInformation/excel/data/psstest/{groupId}/{countryCode}" and http method "POST" to call the back-end.
    
        * @param {string} groupId
        * @param {string} countryCode
        * @param {File} excelFile
        * @returns {DataInformationElementDownloadDto[]}
    ******************************************************************************************************/
    ImportPssTestDataExcel: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.excelFile)
            fd.append("excelFile", data.excelFile);
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/customerInformation/excel/data/psstest/{groupId}/{countryCode}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/customerInformation/excel/data/ncbs2020/{groupId}/{countryCode}" and http method "POST" to call the back-end.
    
        * @param {string} groupId
        * @param {string} countryCode
        * @param {File} excelFile
        * @returns {DataInformationElementDownloadDto[]}
    ******************************************************************************************************/
    ImportNcbs2020DataExcel: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.excelFile)
            fd.append("excelFile", data.excelFile);
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/customerInformation/excel/data/ncbs2020/{groupId}/{countryCode}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/customerInformation/excel/data/ncbs2021/{groupId}/{countryCode}" and http method "POST" to call the back-end.
    
        * @param {string} groupId
        * @param {string} countryCode
        * @param {File} excelFile
        * @returns {DataInformationElementDownloadDto[]}
    ******************************************************************************************************/
    ImportNcbs2021DataExcel: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.excelFile)
            fd.append("excelFile", data.excelFile);
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/customerInformation/excel/data/ncbs2021/{groupId}/{countryCode}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/customerInformation/excel/data/ncbs2022/{groupId}/{countryCode}" and http method "POST" to call the back-end.
    
        * @param {string} groupId
        * @param {string} countryCode
        * @param {File} excelFile
        * @returns {DataInformationElementDownloadDto[]}
    ******************************************************************************************************/
    ImportNcbs2022DataExcel: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.excelFile)
            fd.append("excelFile", data.excelFile);
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/customerInformation/excel/data/ncbs2022/{groupId}/{countryCode}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/customerInformation/excel/data/ncbs2023/{groupId}/{countryCode}" and http method "POST" to call the back-end.
    
        * @param {string} groupId
        * @param {string} countryCode
        * @param {File} excelFile
        * @returns {DataInformationElementDownloadDto[]}
    ******************************************************************************************************/
    ImportNcbs2023DataExcel: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.excelFile)
            fd.append("excelFile", data.excelFile);
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/customerInformation/excel/data/ncbs2023/{groupId}/{countryCode}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/customerInformation/news/{groupId?}" and http method "GET" to call the back-end.
    
        * @param {string} groupId
        * @returns {NewsInformationElementDownloadDto[]}
    ******************************************************************************************************/
    GetNews: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/customerInformation/news/{groupId?}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/customerInformation/news/{groupId}" and http method "POST" to call the back-end.
    
        * @param {string} groupId
        * @param {NewsInformationElementUploadDto} data
        * @param {File} mediaBytes
        * @param {{[key: string]: File}} multipleMediaBytes
        * @param {File} text
        * @param {{[key: string]: File}} downloadBytes
        * @returns {NewsInformationElementDownloadDto}
    ******************************************************************************************************/
    AddNews: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("data", JSON.stringify(data.data));
        if (data.mediaBytes)
            fd.append("mediaBytes", data.mediaBytes);
        _.forEach(data.multipleMediaBytes, function (val, key) { return fd.append(key, val); });
        if (data.text)
            fd.append("text", data.text);
        _.forEach(data.downloadBytes, function (val, key) { return fd.append(key, val); });
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/customerInformation/news/{groupId}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/customerInformation/news/{id}" and http method "PATCH" to call the back-end.
    
        * @param {string} id
        * @param {NewsInformationElementUploadDto} data
        * @param {File} mediaBytes
        * @param {{[key: string]: File}} multipleMediaBytes
        * @param {File} text
        * @param {{[key: string]: File}} downloadBytes
        * @returns {NewsInformationElementDownloadDto}
    ******************************************************************************************************/
    UpdateNews: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("data", JSON.stringify(data.data));
        if (data.mediaBytes)
            fd.append("mediaBytes", data.mediaBytes);
        _.forEach(data.multipleMediaBytes, function (val, key) { return fd.append(key, val); });
        if (data.text)
            fd.append("text", data.text);
        _.forEach(data.downloadBytes, function (val, key) { return fd.append(key, val); });
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/customerInformation/news/{id}", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/customerInformation/news/additional/{id}" and http method "PATCH" to call the back-end.
    
        * @param {string} id
        * @param {File} text
        * @param {MediaUploadDto[]} downloadMediaDtos
        * @param {{[key: string]: File}} downloadBytes
        * @returns {NewsInformationElementDownloadDto}
    ******************************************************************************************************/
    UpdateNewsAdditionalData: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.text)
            fd.append("text", data.text);
        if (data.downloadMediaDtos !== undefined)
            fd.append("downloadMediaDtos", JSON.stringify(data.downloadMediaDtos));
        _.forEach(data.downloadBytes, function (val, key) { return fd.append(key, val); });
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/customerInformation/news/additional/{id}", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/customerInformation/excel/data/cap2020/{groupId}/{countryCode}" and http method "POST" to call the back-end.
    
        * @param {string} groupId
        * @param {string} countryCode
        * @param {File} excelFile
        * @returns {DataInformationElementDownloadDto[]}
    ******************************************************************************************************/
    ImportCaP2020DataExcel: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.excelFile)
            fd.append("excelFile", data.excelFile);
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/customerInformation/excel/data/cap2020/{groupId}/{countryCode}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/customerInformation/excel/data/cap2021/{groupId}/{countryCode}" and http method "POST" to call the back-end.
    
        * @param {string} groupId
        * @param {string} countryCode
        * @param {File} excelFile
        * @returns {DataInformationElementDownloadDto[]}
    ******************************************************************************************************/
    ImportCaP2021DataExcel: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.excelFile)
            fd.append("excelFile", data.excelFile);
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/customerInformation/excel/data/cap2021/{groupId}/{countryCode}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/customerInformation/excel/data/cap2022/{groupId}/{countryCode}" and http method "POST" to call the back-end.
    
        * @param {string} groupId
        * @param {string} countryCode
        * @param {File} excelFile
        * @returns {DataInformationElementDownloadDto[]}
    ******************************************************************************************************/
    ImportCaP2022DataExcel: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.excelFile)
            fd.append("excelFile", data.excelFile);
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/customerInformation/excel/data/cap2022/{groupId}/{countryCode}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/customerInformation/excel/data/cap2023/{groupId}/{countryCode}" and http method "POST" to call the back-end.
    
        * @param {string} groupId
        * @param {string} countryCode
        * @param {File} excelFile
        * @returns {DataInformationElementDownloadDto[]}
    ******************************************************************************************************/
    ImportCaP2023DataExcel: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.excelFile)
            fd.append("excelFile", data.excelFile);
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/customerInformation/excel/data/cap2023/{groupId}/{countryCode}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/customerInformation/excel/data/vp/{groupId}/{year}" and http method "POST" to call the back-end.
    
        * @param {string} groupId
        * @param {number} year
        * @param {File} excelFile
        * @returns {DataInformationElementDownloadDto[]}
    ******************************************************************************************************/
    ImportVpDataExcel: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.excelFile)
            fd.append("excelFile", data.excelFile);
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/customerInformation/excel/data/vp/{groupId}/{year}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/customerInformation/excel/data/pfs/{groupId}/{countryCode}/{year}" and http method "POST" to call the back-end.
    
        * @param {string} groupId
        * @param {string} countryCode
        * @param {number} year
        * @param {File} excelFile
        * @returns {DataInformationElementDownloadDto[]}
    ******************************************************************************************************/
    ImportPfsDataExcel: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.excelFile)
            fd.append("excelFile", data.excelFile);
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/customerInformation/excel/data/pfs/{groupId}/{countryCode}/{year}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/customerInformation/excel/data/jdpower/{groupId}/{countryCode}" and http method "POST" to call the back-end.
    
        * @param {string} groupId
        * @param {string} countryCode
        * @param {File} excelFile
        * @returns {DataInformationElementDownloadDto[]}
    ******************************************************************************************************/
    ImportJdPowerDataExcel: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.excelFile)
            fd.append("excelFile", data.excelFile);
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/customerInformation/excel/data/jdpower/{groupId}/{countryCode}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/customerInformation/data/all/{groupId}" and http method "DELETE" to call the back-end.
    
        * @param {string} groupId
        * @returns {void}
    ******************************************************************************************************/
    DeleteAllDataElements: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/customerInformation/data/all/{groupId}", __assign({}, data)),
            method: "DELETE",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/customerInformation/data/{groupId}/name/{name}" and http method "DELETE" to call the back-end.
    
        * @param {string} groupId
        * @param {string} name
        * @returns {void}
    ******************************************************************************************************/
    DeleteDataByName: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/customerInformation/data/{groupId}/name/{name}", __assign({}, data)),
            method: "DELETE",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/customerInformation/excel/data/vx2020/{groupId}" and http method "POST" to call the back-end.
    
        * @param {string} groupId
        * @param {File} excelFile
        * @returns {DataInformationElementDownloadDto[]}
    ******************************************************************************************************/
    ImportVx2020DataExcel: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.excelFile)
            fd.append("excelFile", data.excelFile);
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/customerInformation/excel/data/vx2020/{groupId}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/customerInformation/excel/data/vx2021/{groupId}" and http method "POST" to call the back-end.
    
        * @param {string} groupId
        * @param {File} excelFile
        * @returns {DataInformationElementDownloadDto[]}
    ******************************************************************************************************/
    ImportVx2021DataExcel: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.excelFile)
            fd.append("excelFile", data.excelFile);
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/customerInformation/excel/data/vx2021/{groupId}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/customerInformation/excel/data/vci/{groupId}" and http method "POST" to call the back-end.
    
        * @param {string} groupId
        * @param {File} excelFile
        * @returns {DataInformationElementDownloadDto[]}
    ******************************************************************************************************/
    ImportVciDataExcel: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.excelFile)
            fd.append("excelFile", data.excelFile);
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/customerInformation/excel/data/vci/{groupId}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/customerInformation/excel/data/complaints/{groupId}/{year}" and http method "POST" to call the back-end.
    
        * @param {string} groupId
        * @param {number} year
        * @param {File} excelFile
        * @returns {DataInformationElementDownloadDto[]}
    ******************************************************************************************************/
    ImportComplaintsDataExcel: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.excelFile)
            fd.append("excelFile", data.excelFile);
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/customerInformation/excel/data/complaints/{groupId}/{year}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/customerInformation/hasNewData/{lastTime}/{groupId?}" and http method "GET" to call the back-end.
    
        * @param {number} lastTime
        * @param {string} groupId
        * @returns {boolean}
    ******************************************************************************************************/
    HasNewData: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/customerInformation/hasNewData/{lastTime}/{groupId?}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/customerInformation/sendPushNotification/{groupId}/{userId?}" and http method "POST" to call the back-end.
    
        * @param {string} groupId
        * @param {SendPushNotificationDto} data
        * @param {string} userId
        * @returns {string}
    ******************************************************************************************************/
    SendPushNotification: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/customerInformation/sendPushNotification/{groupId}/{userId?}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.data
        });
    },
    /*****************************************************************************************************
        * Is using route "api/customerInformation/informationElement/stats/viewed" and http method "POST" to call the back-end.
    
        * @param {EventFilterDto} filter
        * @returns {InformationElementViewedDto[]}
    ******************************************************************************************************/
    GetInformationElementStats: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/customerInformation/informationElement/stats/viewed", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.filter
        });
    },
    /*****************************************************************************************************
        * Is using route "api/customerInformation/searchNews" and http method "POST" to call the back-end.
    
        * @param {string} text
        * @param {string} lng
        * @param {FetchPostsFilter} filter
        * @returns {ExtendedDataCollection<ItemSearchResult<NewsInformationElementDownloadDto>, string>}
    ******************************************************************************************************/
    SearchNews: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("text", JSON.stringify(data.text));
        if (data.lng !== undefined)
            fd.append("lng", JSON.stringify(data.lng));
        if (data.filter !== undefined)
            fd.append("filter", JSON.stringify(data.filter));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/customerInformation/searchNews", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/customerInformation/suggestNews" and http method "POST" to call the back-end.
    
        * @param {string} term
        * @param {string} lng
        * @param {FetchPostsFilter} filter
        * @returns {string[]}
    ******************************************************************************************************/
    SuggestNews: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("term", JSON.stringify(data.term));
        if (data.lng !== undefined)
            fd.append("lng", JSON.stringify(data.lng));
        if (data.filter !== undefined)
            fd.append("filter", JSON.stringify(data.filter));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/customerInformation/suggestNews", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/customerInformation/personaPost/{groupId}" and http method "POST" to call the back-end.
    
        * @param {string} groupId
        * @param {PersonaPostUploadDto} data
        * @param {File} mediaBytes
        * @param {File} portraitBytes
        * @param {{[key: string]: File}} downloadBytes
        * @returns {PersonaPostDownloadDto}
    ******************************************************************************************************/
    AddPersonaPost: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("data", JSON.stringify(data.data));
        if (data.mediaBytes)
            fd.append("mediaBytes", data.mediaBytes);
        if (data.portraitBytes)
            fd.append("portraitBytes", data.portraitBytes);
        _.forEach(data.downloadBytes, function (val, key) { return fd.append(key, val); });
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/customerInformation/personaPost/{groupId}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/customerInformation/milieuPost/{groupId}" and http method "POST" to call the back-end.
    
        * @param {string} groupId
        * @param {MilieuPostUploadDto} data
        * @param {File} mediaBytes
        * @param {{[key: string]: File}} imageBytes
        * @returns {MilieuPostDownloadDto}
    ******************************************************************************************************/
    AddMilieuPost: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("data", JSON.stringify(data.data));
        if (data.mediaBytes)
            fd.append("mediaBytes", data.mediaBytes);
        _.forEach(data.imageBytes, function (val, key) { return fd.append(key, val); });
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/customerInformation/milieuPost/{groupId}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/customerInformation/importMilieusAndPersonas/{groupId}" and http method "POST" to call the back-end.
    
        * @param {string} groupId
        * @param {File} packageBytes
        * @returns {MilieuPostDownloadDto}
    ******************************************************************************************************/
    ImportMilieusAndPersonas: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.packageBytes)
            fd.append("packageBytes", data.packageBytes);
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/customerInformation/importMilieusAndPersonas/{groupId}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
};
/*
$PrintDebugInfo
*/ 
//# sourceMappingURL=CustomerInformationController.js.map